// Module
var code = "<i style=margin-top:3px name=toggleColumns class=\"fa fa-plus-square-o pull-right\" ng-class=\"{'fa-minus-square-o': isActive, 'fa-plus-square-o': !isActive}\" ng-click=\"action();isActive = !isActive\"></i>";
// Exports
module.exports = code;